import i18n from 'i18nextInstance';

export const downloadHeaders = [{
    key: 'created_at',
    label: i18n.t('Creado')
}, {
    key: 'patient_identification',
    label: i18n.t('DNIPaciente')
}, {
    key: 'patient_last_name',
    label: i18n.t('Apellido')
}, {
    key: 'patient_first_name',
    label: i18n.t('Nombre')
}, {
    key: 'type',
    label: i18n.t('Tipo')
}, {
    key: 'company',
    label: i18n.t('Empresa')
}, {
    key: 'finalized_at',
    label: i18n.t('Finalizado')
}, {
    key: 'sent_at',
    label: i18n.t('Enviado')
}, {
    key: 'exams',
    label: i18n.t('Pruebas realizadas')
}];
